<template>
  <PageWrapper
    :active-section="SECTION_EXPLORE"
    :active-page="PAGE_EXPLORE_STORIES"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap">
      <SmartFeed
        :pinia-store="exploreStoriesFeedStore"
        default-smart-feed-layout="grid"
        default-entity-layout="cardLarge"
        load-more-behavior="auto"
      />
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { PAGE_EXPLORE_STORIES, SECTION_EXPLORE } from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";

export default {
  name: "ExploreStories",
  components: {
    PageWrapper,
    SmartFeed,
  },
  data() {
    return {
      SECTION_EXPLORE,
      PAGE_EXPLORE_STORIES,
    };
  },
  computed: {
    exploreStoriesFeedStore() {
      return SmartFeedEngine.getFeedPiniaStore("ExploreStoriesFeedSource");
    },
  },
};
</script>
